import { Layout } from '@loadsmart/miranda-react'

import { hasItemCommodity } from 'core/domain/Load'
import {
  getCommodities,
  getFormattedRate,
  getFormattedRatePerMile,
} from 'core/presenters/loadPresenter'
import { formatDate, formatLocation } from 'core/presenters/stopPresenter'
import { getTruckLabel } from 'core/presenters/truckPresenter'
import { CardInfoItem } from 'core/ui/components/card/CardInfoItem'
import { VerticalDivider } from 'core/ui/components/divider/VerticalDivider'
import { ShipperInformation } from 'core/ui/components/shipper/ShipperInformation'
import { LaneInformation } from 'core/ui/components/stop/LaneInformation'

import { LoadDeadline } from './LoadDeadline'
import { LoadRate } from './LoadRate'
import { type TenderCardProps } from './TenderCard'
import { DesktopBodyWrapper, CardWrapper, DeadlineWrapper } from './TenderCard.styles'
import { TenderConfirmation, TenderAnalyticsContext } from './TenderConfirmation'

export function TenderCardDesktop({ disabled = false, load, onAccept, onReject }: TenderCardProps) {
  const { mileage, shipper, stops } = load

  return (
    <CardWrapper data-testid="tender-card">
      <DeadlineWrapper>
        <LoadDeadline load={load} />
      </DeadlineWrapper>
      <DesktopBodyWrapper>
        <Layout.Group align="center" justify="space-between">
          <LaneInformation
            stops={stops}
            distance={mileage}
            valueFormatter={formatLocation}
            extraFormatter={formatDate}
            distanceUnit="miles"
            data-testid="tender-card-lane-information"
          />
          <LoadRate
            rate={getFormattedRate(load)}
            ratePerMile={getFormattedRatePerMile(load)}
            providerRateId={load.providerRateId}
            data-testid="tender-card-load-rate"
          />
        </Layout.Group>
        <Layout.Group align="center" justify="space-between" gap="spacing-6">
          <Layout.Group
            align="center"
            justify="space-between"
            gap="spacing-6"
            data-testid="tender-card-extra-information"
          >
            {shipper && (
              <ShipperInformation
                companyName={shipper?.companyName}
                logo={shipper?.logoUrl}
                showContactInfo={false}
                data-testid="tender-card-shipper-information"
              />
            )}
            <VerticalDivider />
            <CardInfoItem title="Mode" value={load.mode} />
            <VerticalDivider />
            <CardInfoItem title="Equipment" value={getTruckLabel(load.equipmentType)} />
            {hasItemCommodity(load) && (
              <>
                <VerticalDivider />
                <CardInfoItem
                  title="Commodity"
                  value={getCommodities(load)}
                  style={{ flexGrow: 1 }}
                />
              </>
            )}
          </Layout.Group>
          <TenderConfirmation
            context={TenderAnalyticsContext.LoadBoard}
            disabled={disabled}
            load={load}
            onAccept={onAccept}
            onReject={onReject}
          />
        </Layout.Group>
      </DesktopBodyWrapper>
    </CardWrapper>
  )
}
